import { TraceSequence } from '@/classes/models'

export default class Trace {
  /**
   * Create new trace and set properties based on the given object.
   *
   * @param {Object} obj
   */
  constructor (obj) {
    Object.assign(this, obj)

    // Map invoices to Invoice
    if (typeof this.traceSequences !== 'undefined') {
      this.traceSequences = this.traceSequences.map((traceSequence, index) => new TraceSequence(traceSequence, index))
    }
  }
}
